export const ROUTES = {
  swap: '/swap',
  portfolio: '/portfolio',
  staking: '/staking',
  claim: '/claim',

  internal: {
    baultAnalytics: '/internal/bault-analytics',
  },

  liquidity: {
    index: '/liquidity',
    topPools: '/liquidity/pools',
    farms: '/liquidity/farms',

    v2: {
      index: '/liquidity/v2',
      find: '/liquidity/v2/find',
      add: (token0: string, token1: string) => `/liquidity/v2/add/${token0}/${token1}`,
      remove: (token0: string, token1: string) => `/liquidity/v2/remove/${token0}/${token1}`,
    },

    v3: {
      index: '/liquidity/v3',
      add: (token0: string, token1: string, fee: number) => `/liquidity/v3/add/${token0}/${token1}/${fee}`,
      remove: (tokenId: string | number) => `/liquidity/v3/remove/${tokenId}`,
      increase: (token0: string, token1: string, fee: number, tokenId: string | number) =>
        `/liquidity/v3/increase/${token0}/${token1}/${fee}/${tokenId}`,
    },
  },

  farms: {
    index: '/farms',
    detail: (farmId: string) => `/farms/${farmId}`,
    deploy: '/liquidity/farms/deploy',
    configure: (farmId: string) => `/liquidity/farms/configure/${farmId}`,
    single: (farmAddress: string) => `/liquidity/farms/single/${farmAddress}`,
  },

  islands: {
    detail: (tokenId: string, farmId?: string) =>
      farmId ? `/liquidity/pools/${tokenId}?farm=${farmId}` : `/liquidity/pools/${tokenId}`,
  },

  explore: {
    index: '/explore',
    version: (version: 'v2' | 'v3') => `/explore/${version}`,
    view: (version: 'v2' | 'v3', view: string) => `/explore/${version}/${view}`,
    pool: (version: 'v2' | 'v3', poolId: string) => `/explore/${version}/pools/${poolId}`,
    token: (version: 'v2' | 'v3', tokenId: string) => `/explore/${version}/tokens/${tokenId}`,
  },
} as const
